import { createRequiredContext } from 'src/context/createRequiredContext';

import { useMembershipActionsSlice } from './useMembershipActionsSlice';

const [useMembershipActions, MembershipActionsProvider] =
  createRequiredContext<ReturnType<typeof useMembershipActionsSlice>>();

const MembershipActionsContextProvider = ({ children }: React.PropsWithChildren) => {
  const value = useMembershipActionsSlice();

  return <MembershipActionsProvider value={value}>{children}</MembershipActionsProvider>;
};

export { useMembershipActions, MembershipActionsContextProvider };
